<div class="flex flex-column h-full">
  <div class="flex-grow-1 border-solid border-1 surface-border">
    <ace [config]="aceconfig" [(value)]="newValue" (change)="handleDirty()" [mode]="syntax"></ace>
  </div>

  <button
    *ngIf="saveIcon"
    pButton
    [disabled]="!isValid || !isDirty"
    (click)="save()"
    [label]="saveButtonLabel"
    [icon]="saveIcon"
    class="mt-3 w-min"
  ></button>
</div>
